<div class="comment">
    <div class="comment-image-container">
        <ng-container *ngIf="ConpareInt(comment.userId)">
            <div class="encuadre"><img class="imageAStyle" src="../../../../assets/ceplan-chat.png" /></div>
        </ng-container>
        <ng-container *ngIf="!ConpareInt(comment.userId)">
            <div class="encuadre"><img class="imageBStyle" src="../../../../assets/chat-icon.png" /></div>
        </ng-container>
    </div>
    <div class="comment-right-part">
        <div class="comment-content">
            <div class="comment-author">{{ comment.username|titlecase }}<ng-container
                    *ngIf="ConpareInt(comment.userId)"> (Ceplan)
                </ng-container>
            </div>
        </div>
        <div class="comment-text" *ngIf="!isEditing()">{{ comment.body }}</div>
        <div class="comments-time"> {{comment.createdAt | date:'short':'IST'}}</div>
        <app-comment-form *ngIf="isEditing()" submitLabel="Editar" [hasCancelButton]="true" [initialText]="comment.body"
            [initialEmail]="comment.email" [initialUsername]="comment.username" [initialLastname]="comment.lastname"
            [initialSurname]="comment.surname"
            (handleSubmit)="updateComment.emit({ info: $event, commentId: comment.id })"
            (handleCancel)="setActiveComment.emit(null)">
        </app-comment-form>

        <div class="comment-actions">
            <div *ngIf="canReply" class="comment-action"
                (click)="setActiveComment.emit({id: comment.id,type: activeCommentType.replying})">
                Responder
            </div>
            <div *ngIf="canEdit" class="comment-action"
                (click)="setActiveComment.emit({id: comment.id, type: activeCommentType.editing})">
                Editar
            </div>
            <div *ngIf="canDelete" class="comment-action" (click)="deleteComment.emit(comment.id)">
                Eliminar
            </div>
        </div>

        <app-comment-form *ngIf="isReplying()" submitLabel="Responder" [hasCancelButton]="true"
            (handleSubmit)="addComment.emit({ info: $event, parentId: replyId })"
            (handleCancel)="setActiveComment.emit(null)">
        </app-comment-form>

        <div class="replies" *ngIf="replies.length > 0">
            <app-comment *ngFor="let reply of replies" [comment]="reply"
                (setActiveComment)="setActiveComment.emit($event)" [activeComment]="activeComment"
                (addComment)="addComment.emit($event)" [parentId]="comment.id" [replies]="[]"
                [currentUserId]="currentUserId" (updateComment)="updateComment.emit($event)"
                (deleteComment)="deleteComment.emit($event)">
            </app-comment>
        </div>

    </div>
</div>